export const UserRoles = {
    SET_USERROLES:"SET_USERROLES",
  }